module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-kpito-03.2c12ac45.jpg";